import MuiThemeProvider from "components/MuiThemeProvider";
import PageInfoCardAdornment from "components/Layout/PageInfoCardAdornment";
import LeaderboardsInfoCard from "../LeaderboardsInfoCard";

function LeaderboardsInfoCardAdornment() {
  return (
    <PageInfoCardAdornment pageTitle="leaderboards">
      {(props) => (
        <MuiThemeProvider>
          <LeaderboardsInfoCard onClose={props.onClose} />
        </MuiThemeProvider>
      )}
    </PageInfoCardAdornment>
  );
}

export default LeaderboardsInfoCardAdornment;
